var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.182,
    height: 74.304,
    viewBox: "0 0 282.182 74.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_240904",
    "data-name": "Group 240904",
    transform: "translate(-559.346 -376.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left_dotline_small",
    d: "M143.356,0S106,26.592,69.438,37.641,0,73,0,73",
    transform: "translate(559.644 376.5)",
    fill: "none",
    stroke: "#7dad21",
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "right_dotline_small",
    d: "M0,0S35.889,26.592,71.014,37.641,137.724,73,137.724,73",
    transform: "translate(703.5 377)",
    fill: "none",
    stroke: "#7dad21",
    strokeWidth: 1,
    strokeDasharray: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoLines);
export default __webpack_public_path__ + "static/media/two-lines.092ddcb9d23a0cadc9a8ad82718d8e3b.svg";
export { ForwardRef as ReactComponent };